import {
  type AccordionProps,
  Accordion as KitAccordion,
} from "@pepperstone/pepper-ui-kit";
import styles from "./Accordion.module.css";

export function Accordion({
  children,
  className = "",
  ...rest
}: AccordionProps) {
  return (
    <section className={styles.accordion}>
      <KitAccordion
        {...rest}
        className={`${styles.item} ${className}`}
        headerClasses={styles.header}
        contentClasses={styles.content}
      >
        {children}
      </KitAccordion>
    </section>
  );
}

Accordion.Header = KitAccordion.Header;
Accordion.Body = KitAccordion.Body;
